import * as React from "react"
// Set default icon color
//
// To add a new color, create a new case with the value and
// name of the color.

export const Logo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="104"
      height="24"
      fill="none"
      viewBox="0 0 104 24"
    >
      <path
        fill="#00FF7F"
        d="M67.391 20.808l.474-.963a1.868 1.868 0 00.066.963h-.54zm.982-1.993l7.006-14.22a2.75 2.75 0 01.978-1.104 2.859 2.859 0 011.562-.453v-.006c.57 0 1.1.159 1.557.453v.005c.417.27.755.642.982 1.099h.002l7.078 14.333c-.792-1.072-2.552-1.963-4.846-2.487L77.919 6.77l-4.76 9.66c-2.228.506-3.956 1.358-4.786 2.386zm19.564.913l.533 1.08h-.572a1.88 1.88 0 00.039-1.08z"
      ></path>
      <path
        fill="#0A0A29"
        d="M48.542 20.762l.056-15.386a2.22 2.22 0 01.546-1.448 2.624 2.624 0 011.41-.833v-.002a2.814 2.814 0 011.672.128c.514.207.952.565 1.233 1.043l4.162 7.048 4.183-7.07c.283-.48.72-.837 1.234-1.043a2.81 2.81 0 011.673-.127 2.613 2.613 0 011.41.837h.006c.345.404.544.908.544 1.45h-.006l-.004 15.483h-3.293l.003-12.916-3.473 5.871a2.454 2.454 0 01-.95.908c-.394.214-.847.33-1.328.33v.005c-.475 0-.928-.118-1.328-.336a2.455 2.455 0 01-.95-.907l-3.46-5.861-.046 12.826h-3.294z"
      ></path>
      <path
        fill="#0A0A29"
        fillRule="evenodd"
        d="M89.034 20.762l.029-15.164c0-.354.07-.683.21-.987.141-.308.348-.587.62-.832.27-.244.575-.43.916-.557.34-.127.702-.19 1.084-.189l4.662.02v-.005h.005c2.054 0 3.913.76 5.259 1.986C103.167 6.26 104 7.956 104 9.828c0 1.861-.828 3.55-2.168 4.778-1.337 1.225-3.187 1.986-5.236 1.998h-4.262l-.008 4.158h-3.292zm3.321-14.728l-.015 7.57h4.244a4.335 4.335 0 002.91-1.115c.743-.68 1.201-1.62 1.201-2.66 0-1.042-.464-1.985-1.213-2.667-.748-.682-1.784-1.104-2.927-1.104v-.442l-.002.436-4.198-.018z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#0A0A29"
        d="M68.51 18.536c.423-.233.886-.448 1.383-.643 2.099-.82 4.897-1.32 7.932-1.32 2.87 0 5.546.451 7.614 1.204h.006c.736.267 1.403.579 1.987.928l1.038 2.102H84.85l-.008-.017v.021a11.557 11.557 0 00-.624-.247v-.002c-1.683-.612-3.927-.98-6.395-.98-2.594 0-4.934.408-6.64 1.075-.126.05-.248.1-.366.15h-3.427l1.12-2.27z"
      ></path>
      <path
        fill="#0A0A29"
        fillRule="evenodd"
        d="M8.428 9.324c1.487 0 2.563.307 3.228.92.665.612.997 1.473.997 2.583 0 1.052-.325 1.863-.973 2.432-.65.57-1.741.854-3.276.854H2.445v.822c0 .461.146.84.44 1.135.292.296.787.443 1.483.443h7.668v2.227H4.368c-.791 0-1.46-.093-2.006-.28-.546-.188-.997-.451-1.353-.79a2.97 2.97 0 01-.772-1.19A4.537 4.537 0 010 16.979v-3.892c0-.533.08-1.03.237-1.492.158-.46.416-.86.772-1.2.356-.338.807-.601 1.353-.789.546-.187 1.215-.28 2.006-.28h4.06zM2.445 14.32h5.888c.68 0 1.159-.123 1.436-.368.277-.245.415-.576.415-.994 0-.433-.142-.779-.427-1.038-.285-.26-.736-.39-1.353-.39H4.368c-.696 0-1.19.152-1.483.455-.293.303-.44.677-.44 1.124v1.21z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#0A0A29"
        d="M21.128 9.324c2.137 0 3.723.436 4.76 1.308 1.036.873 1.554 2.101 1.554 3.687v6.421h-2.54V14.32c0-.908-.297-1.6-.89-2.076s-1.555-.713-2.884-.713H17.02c-.206 0-.309.108-.309.324v8.886h-2.516v-9.643c0-.677.135-1.142.404-1.394.269-.253.72-.379 1.353-.379h5.175zM30.267 9.324l4.178 9.168c.095.23.301.346.618.346.332 0 .554-.116.664-.346l4.345-9.168h2.706l-4.843 10.184c-.27.548-.637.933-1.104 1.157-.467.223-1.056.335-1.768.335-.728 0-1.326-.115-1.793-.346-.467-.23-.819-.612-1.056-1.146L27.61 9.324h2.658zM46.006 9.324V20.74H43.49V9.324h2.516zM46.3 6.066c0 .776-.69 1.405-1.542 1.405-.852 0-1.543-.629-1.543-1.405s.69-1.405 1.543-1.405c.852 0 1.542.63 1.542 1.405z"
      ></path>
    </svg>
  );
};

// Set default icon color
//
// To add a new color, create a new case with the value and
// name of the color.

let fillColor;
export const ColorSwitch = (propColor) => {
  switch (propColor) {
    case "green":
      fillColor = "#00FF7F";
      break;
    case "white":
      fillColor = "#FFF";
      break;
    case "red":
      fillColor = "#FF0055";
      break;
    case "darkGray":
      fillColor = "#A1A1AA";
      break;
    default:
      fillColor = "#0A0A29";
      break;
  }
  return fillColor;
};

// Icons
//
// To add an icon, create an arrow function with the name of the icon,
// give it the input value "props", call the ColorSwitch function at
// the beginning with the value "props.color" and return the svg code.

export const Add = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M21 11.001h-8v-8h-2v8H3v2h8v8h2v-8h8v-2z"
      ></path>
    </svg>
  );
};

export const ArrowBackward = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
      ></path>
    </svg>
  );
};

export const ArrowForward = props => {
  ColorSwitch(props.color)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g fill={fillColor}>
        <path d="M12 4L10.5867 5.41333L16.1733 11H4V13H16.1733L10.5867 18.5867L12 20L20 12L12 4Z"/>
      </g>
    </svg>
  )
}

export const ArrowDown = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
      ></path>
    </svg>
  );
};

export const ArrowDropDown = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill={fillColor} d="M6.667 10.666L12 16l5.333-5.334H6.667z"></path>
    </svg>
  );
};

export const ArrowLeft = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
       fill={fillColor}
        d="M12.842 6.175L11.667 5l-5 5 5 5 1.175-1.175L9.025 10l3.817-3.825z"
      ></path>
    </svg>
  );
};
export const ArrowRight = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 4l-1.413 1.413L16.173 11H4v2h12.173l-5.586 5.587L12 20l8-8-8-8z"
      ></path>
    </svg>
  );
};
export const ArrowRightSmall = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={fillColor}
        d="M6.667 4l-.94.94L8.78 8l-3.053 3.06.94.94 4-4-4-4z"
      ></path>
    </svg>
  );
};

export const AutoRotate = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M3 11C3 10.2021 3.67281 9.21056 5.37615 8.35889C7.01967 7.53713 9.36016 7 12 7C14.6398 7 16.9803 7.53713 18.6239 8.35889C20.3272 9.21056 21 10.2021 21 11C21 11.6483 20.568 12.4213 19.446 13.168C18.9862 13.474 18.8615 14.0947 19.1675 14.5545C19.4735 15.0143 20.0942 15.139 20.554 14.833C21.9436 13.9082 23 12.6034 23 11C23 9.03646 21.4342 7.52801 19.5183 6.57004C17.5425 5.58216 14.883 5 12 5C9.11699 5 6.45748 5.58216 4.48172 6.57004C2.56577 7.52801 1 9.03646 1 11C1 12.9635 2.56577 14.472 4.48172 15.43C5.99067 16.1844 7.89844 16.7023 10 16.9048V21L17 16L10 11V14.8946C8.18517 14.7 6.59043 14.2483 5.37615 13.6411C3.67281 12.7894 3 11.7979 3 11Z"
      />
    </svg>
  );
};

export const Bin = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M15 3v2h6v2H3V5h6V3h6zM11 12H9v6h2v-6zM13 12h2v6h-2v-6z"
      ></path>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M7 22c-1.103 0-2-.897-2-2V8h14v12c0 1.103-.897 2-2 2H7zm10-12H7v10h10.001L17 10z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};

export const Close = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M20.749 4.707l-1.415-1.414-7.292 7.293-7.293-7.293-1.415 1.414L10.627 12l-7.293 7.293 1.415 1.414 7.293-7.293 7.292 7.293 1.415-1.414L13.456 12l7.293-7.293z"
      ></path>
    </svg>
  );
};

export const Copy = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
      />
    </svg>
  );
};

export const Convert = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 4V1L8 5L12 9V6C15.31 6 18 8.69 18 12C18 13.01 17.75 13.97 17.3 14.8L18.76 16.26C19.54 15.03 20 13.57 20 12C20 7.58 16.42 4 12 4V4ZM12 18C8.69 18 6 15.31 6 12C6 10.99 6.25 10.03 6.7 9.2L5.24 7.74C4.46 8.97 4 10.43 4 12C4 16.42 7.58 20 12 20V23L16 19L12 15V18Z"
      />
    </svg>
  );
};

export const Cursor = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      {props.multi ? (
        <>
          <path
            fill={fillColor}
            d="M10.4207 21.9996C9.99753 21.9996 9.61017 21.7438 9.44702 21.348L2.07876 3.4537C1.91771 3.06213 2.00824 2.60951 2.30823 2.30846C2.60823 2.00742 3.06085 1.91794 3.45347 2.07899L21.3478 9.44725C21.7678 9.62093 22.0299 10.0441 21.9973 10.4978C21.9636 10.9514 21.6436 11.3314 21.2015 11.443L13.3932 13.3945L11.4417 21.2028C11.3312 21.6428 10.9501 21.9638 10.4965 21.9964C10.4723 21.9986 10.4449 21.9996 10.4207 21.9996V21.9996ZM4.98712 4.9884L10.1765 17.5881L11.5049 12.2725C11.5996 11.8956 11.8943 11.5998 12.2722 11.5062L17.5889 10.1767L4.98712 4.9884V4.9884Z"
          />
          <path
            fill={fillColor}
            d="M17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
          />
        </>
      ) : (
        <path
          fill={fillColor}
          d="M10.4207 21.9996C9.99753 21.9996 9.61017 21.7438 9.44702 21.348L2.07876 3.4537C1.91771 3.06213 2.00824 2.60951 2.30823 2.30846C2.60823 2.00742 3.06085 1.91794 3.45347 2.07899L21.3478 9.44725C21.7678 9.62093 22.0299 10.0441 21.9973 10.4978C21.9636 10.9514 21.6436 11.3314 21.2015 11.443L13.3932 13.3945L11.4417 21.2028C11.3312 21.6428 10.9501 21.9638 10.4965 21.9964C10.4723 21.9986 10.4449 21.9996 10.4207 21.9996V21.9996ZM4.98712 4.9884L10.1765 17.5881L11.5049 12.2725C11.5996 11.8956 11.8943 11.5998 12.2722 11.5062L17.5889 10.1767L4.98712 4.9884V4.9884Z"
        />
      )}
    </svg>
  );
};

export const Cookie = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M17 3C17 3.55228 16.5523 4 16 4C15.4477 4 15 3.55228 15 3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3Z"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 12C5 10.346 6.346 9 8 9C9.654 9 11 10.346 11 12C11 13.654 9.654 15 8 15C6.346 15 5 13.654 5 12ZM7 12C7 12.551 7.449 13 8 13C8.551 13 9 12.551 9 12C9 11.449 8.551 11 8 11C7.449 11 7 11.449 7 12Z"
      />
      <path
        fill={fillColor}
        d="M16.001 15C16.5533 15 17.001 14.5523 17.001 14C17.001 13.4477 16.5533 13 16.001 13C15.4487 13 15.001 13.4477 15.001 14C15.001 14.5523 15.4487 15 16.001 15Z"
      />
      <path
        fill={fillColor}
        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.61 9.89105C20.892 9.80005 21.201 9.83905 21.453 9.99805C21.704 10.1571 21.871 10.4191 21.908 10.7151C21.971 11.1991 22 11.6071 22 12.0001C22 17.5151 17.514 22.0001 12 22.0001C6.486 22.0001 2 17.5151 2 12.0001C2 6.67505 6.169 2.29205 11.492 2.02505C11.857 2.00405 12.203 2.18905 12.394 2.49905C12.586 2.81105 12.592 3.20205 12.41 3.51905C12.139 3.99505 12 4.49305 12 5.00005C12 6.65405 13.346 8.00005 15 8.00005C15.531 8.00005 16.045 7.85305 16.529 7.56405C16.817 7.39205 17.171 7.37505 17.474 7.52005C17.776 7.66405 17.986 7.95105 18.033 8.28205C18.172 9.26105 19.018 10.0001 20 10.0001C20.184 10.0001 20.377 9.96505 20.61 9.89105ZM4 12.0001C4 16.4111 7.589 20.0001 12 20.0001C16.411 20.0001 20 16.4111 20 12.0001C18.464 12.0001 17.095 11.1041 16.434 9.78205C15.966 9.92605 15.482 10.0001 15 10.0001C12.243 10.0001 10 7.75705 10 5.00005C10 4.74705 10.02 4.49605 10.059 4.24805C6.561 5.11505 4 8.26805 4 12.0001Z"
      />
      <path
        fill={fillColor}
        d="M21 6C21.5523 6 22 5.55228 22 5C22 4.44772 21.5523 4 21 4C20.4477 4 20 4.44772 20 5C20 5.55228 20.4477 6 21 6Z"
      />
    </svg>
  );
};

export const Done = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
      ></path>
    </svg>
  );
};

export const Download = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16.293 9.294l1.414 1.414L12 16.415l-5.707-5.707 1.414-1.414L11 12.587V2.001h2v10.586l3.293-3.293zM18 20.001v-2h2v2c0 1.102-.896 2-2 2H6c-1.104 0-2-.898-2-2v-2h2v2h12z"
      ></path>
    </svg>
  );
};

export const Edit = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M20.821 3.179A3.997 3.997 0 0017.974 2a3.997 3.997 0 00-2.846 1.179L3.719 14.587l-.003.004a1.274 1.274 0 00-.261.461L2.03 20.756a.997.997 0 00.263.949l.001.001.001.001a1 1 0 00.949.264l5.704-1.427a1.266 1.266 0 00.465-.264L20.822 8.873A3.996 3.996 0 0022 6.026a4.002 4.002 0 00-1.178-2.847h-.001zm-6.41 3.549l2.863 2.863-8.568 8.568-2.863-2.863 8.568-8.568zM4.375 19.626l.595-2.374 1.78 1.781-2.375.593zM19.409 4.594c.764.765.764 2.099 0 2.864l-.719.72-2.866-2.865.721-.719c.765-.764 2.099-.765 2.864 0z"
      ></path>
    </svg>
  );
};

export const Expand = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      {props.expanded ? (
        <>
          <path
            fill={fillColor}
            d="M4 18.6L5.4 20L10 15.4V19H12V12H5V14H8.6L4 18.6Z"
          />
          <path
            fill={fillColor}
            d="M20 5.4L18.6 4L14 8.6V5H12V12H19V10H15.4L20 5.4Z"
          />
        </>
      ) : (
        <path
          fill={fillColor}
          d="M13 6H16.586L6 16.586V13H4V20H11V18H7.414L18 7.414V11H20V4H13V6Z"
        />
      )}
    </svg>
  );
};

export const Extent = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M9.293 10.707L5 6.414V9H3V3H9V5H6.414L10.707 9.293L9.293 10.707Z"
      />
      <path
        fill={fillColor}
        d="M6.414 19H9V21H3V15H5V17.586L9.293 13.293L10.707 14.707L6.414 19Z"
      />
      <path
        fill={fillColor}
        d="M15 21H21V15H19V17.586L14.707 13.293L13.293 14.707L17.586 19H15V21Z"
      />
      <path
        fill={fillColor}
        d="M15 3H21V9H19V6.414L14.707 10.707L13.293 9.293L17.586 5H15V3Z"
      />
    </svg>
  );
};

export const ExpandMore = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M13 6h3.586L6 16.586V13H4v7h7v-2H7.414L18 7.414V11h2V4h-7v2z"
      ></path>
    </svg>
  );
};

export const Features = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      {props.type === "side" && (
        <path
          fill={fillColor}
          d="M4.41421 11L12 3.41421L19.5858 11H19H18V12V21H6V12V11H5H4.41421Z"
        />
      )}
      {props.type === "edge" && (
        <path
          fill={fillColor}
          d="M12 2L22 12H19V21C19 21.5523 18.5523 22 18 22H6C5.44772 22 5 21.5523 5 21V12H2L12 2ZM6.82843 10H17.1716L12 4.82843L6.82843 10ZM7 12V20H17V12H7Z"
        />
      )}
      {props.type === "solar" && (
        <>
          <path fill={fillColor} d="M13 7H11V8H10V10H11V11H13V10H14V8H13V7Z" />
          <path
            fill={fillColor}
            d="M11 13H13V14H14V16H13V17H11V16H10V14H11V13Z"
          />
          <path
            fill={fillColor}
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 2C5.44772 2 5 2.44772 5 3V21C5 21.5523 5.44772 22 6 22H18C18.5523 22 19 21.5523 19 21V3C19 2.44772 18.5523 2 18 2H6ZM7 4V8H8V10H7V14H8V16H7V20H11V19H13V20H17V16H16V14H17V10H16V8H17V4H13V5H11V4H7Z"
          />
        </>
      )}
    </svg>
  );
};

export const GPS = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
      ></path>
    </svg>
  );
};

export const Hamburger = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill={fillColor} d="M1 5H23V7H1z"></path>
      <path fill={fillColor} d="M1 11H23V13H1z"></path>
      <path fill={fillColor} d="M1 17H23V19H1z"></path>
    </svg>
  );
};

export const HamburgerClose = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={props.clickEvent}
    >
      <path
        fill={fillColor}
        d="M4.929 3.515H26.929000000000002V5.515000000000001H4.929z"
        transform="rotate(45 4.929 3.515)"
      ></path>
      <path
        fill={fillColor}
        d="M3.515 19.071H25.515V21.071H3.515z"
        transform="rotate(-45 3.515 19.071)"
      ></path>
    </svg>
  );
};

export const Help = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12.0921 6.24099C9.96134 6.19083 8.21253 7.87612 8.16005 9.98245C8.15871 10.036 8.20268 10.0799 8.25626 10.0799H9.98558C10.0363 10.0799 10.0789 10.0404 10.0812 9.9898C10.1304 8.92669 11.0441 8.08933 12.1357 8.16455C13.0826 8.22988 13.8497 8.99692 13.9151 9.94372C13.9925 11.0657 13.1051 11.9999 11.9994 11.9999L11.1353 11.9999C11.0823 11.9999 11.0393 12.0429 11.0393 12.0959V13.8239C11.0393 13.8769 11.0823 13.9199 11.1353 13.9199H11.9994C14.1513 13.9199 15.8899 12.1504 15.8389 9.9873C15.791 7.95023 14.1294 6.28895 12.0921 6.24099Z"
      />
      <path
        fill={fillColor}
        d="M12 16.7999C12.5302 16.7999 12.96 16.3701 12.96 15.8399C12.96 15.3097 12.5302 14.8799 12 14.8799C11.4698 14.8799 11.04 15.3097 11.04 15.8399C11.04 16.3701 11.4698 16.7999 12 16.7999Z"
      />
      <path
        fill={fillColor}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.3999C6.69811 2.3999 2.40002 6.69794 2.40002 11.9999C2.40002 17.3019 6.69811 21.5999 12 21.5999C17.302 21.5999 21.6 17.3019 21.6 11.9999C21.6 6.69794 17.302 2.3999 12 2.3999ZM12.0001 19.68C7.75853 19.68 4.32003 16.2415 4.32003 11.9999C4.32003 7.75836 7.75853 4.31991 12.0001 4.31991C16.2417 4.31991 19.6801 7.75836 19.6801 11.9999C19.6801 16.2415 16.2417 19.68 12.0001 19.68Z"
      />
    </svg>
  );
};

export const Home = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill={fillColor} d="M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z" />
    </svg>
  );
};

export const Information = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
      ></path>
    </svg>
  );
};

export const LidarRes = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 7.00098C13.1046 7.00098 14 6.10555 14 5.00098C14 3.89641 13.1046 3.00098 12 3.00098C10.8954 3.00098 10 3.89641 10 5.00098C10 6.10555 10.8954 7.00098 12 7.00098Z"
      />
      <path
        fill={fillColor}
        d="M18 10.5C19.1046 10.5 20 9.60457 20 8.5C20 7.39543 19.1046 6.5 18 6.5C16.8954 6.5 16 7.39543 16 8.5C16 9.60457 16.8954 10.5 18 10.5Z"
      />
      <path
        fill={fillColor}
        d="M8 8.5C8 9.60457 7.10457 10.5 6 10.5C4.89543 10.5 4 9.60457 4 8.5C4 7.39543 4.89543 6.5 6 6.5C7.10457 6.5 8 7.39543 8 8.5Z"
      />
      <path
        fill={fillColor}
        d="M12 14.001C13.1046 14.001 14 13.1055 14 12.001C14 10.8964 13.1046 10.001 12 10.001C10.8954 10.001 10 10.8964 10 12.001C10 13.1055 10.8954 14.001 12 14.001Z"
      />
      <path
        fill={fillColor}
        d="M20 15.5C20 16.6046 19.1046 17.5 18 17.5C16.8954 17.5 16 16.6046 16 15.5C16 14.3954 16.8954 13.5 18 13.5C19.1046 13.5 20 14.3954 20 15.5Z"
      />
      <path
        fill={fillColor}
        d="M6 17.5C7.10457 17.5 8 16.6046 8 15.5C8 14.3954 7.10457 13.5 6 13.5C4.89543 13.5 4 14.3954 4 15.5C4 16.6046 4.89543 17.5 6 17.5Z"
      />
      <path
        fill={fillColor}
        d="M14 19.001C14 20.1055 13.1046 21.001 12 21.001C10.8954 21.001 10 20.1055 10 19.001C10 17.8964 10.8954 17.001 12 17.001C13.1046 17.001 14 17.8964 14 19.001Z"
      />
    </svg>
  );
};

export const Upload = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M11 16V6.416L7.707 9.708 6.293 8.294 12 2.587l5.707 5.707-1.414 1.414L13 6.415V16h-2zM18 20.001v-2h2v2c0 1.102-.896 2-2 2H6c-1.104 0-2-.898-2-2v-2h2v2h12z"
      ></path>
    </svg>
  );
};

export const Pin = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 2C7.589 2 4 5.589 4 10C4 14.411 8.644 19.44 12 22.318C15.354 19.442 20 14.411 20 10C20 5.589 16.411 2 12 2ZM12 19.654C9.87 17.657 6 13.338 6 10C6 6.691 8.691 4 12 4C15.309 4 18 6.691 18 10C18 13.338 14.13 17.657 12 19.654Z"
      />
      <path
        fill={fillColor}
        d="M14 10C14 11.1046 13.1046 12 12 12C10.8954 12 10 11.1046 10 10C10 8.89543 10.8954 8 12 8C13.1046 8 14 8.89543 14 10Z"
      />
    </svg>
  );
};

export const PinDenied = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M21.456 5.414l-2.829-2.828-6.585 6.586-6.586-6.586-2.83 2.828L9.214 12l-6.586 6.586 2.829 2.828 6.586-6.586 6.585 6.586 2.829-2.828L14.87 12l6.586-6.586z"
      ></path>
    </svg>
  );
};

export const PinProcessing = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M5 18.828V21a1 1 0 001 1h12a1 1 0 001-1v-2.172c0-.79-.32-1.562-.879-2.121L13.414 12l4.707-4.707A2.98 2.98 0 0019 5.17V3a1 1 0 00-1-1H6a1 1 0 00-1 1v2.17c0 .802.312 1.555.879 2.121L10.586 12l-4.707 4.707A3.017 3.017 0 005 18.828zM9 4.999h6l-3 3-3-3z"
      ></path>
    </svg>
  );
};

export const Ruler = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16.3828 0L0 16.3828L7.61709 23.9999L23.9999 7.61709L16.3828 0ZM16.3828 2.75061L21.2493 7.61709L7.61709 21.2493L2.75062 16.3828L3.869 15.2644L5.95463 17.3501L7.34506 15.9899L5.2292 13.874L6.3778 12.7556L7.22415 13.602L8.58434 12.2115L7.738 11.3954L8.88661 10.2468L10.9722 12.3325L12.3324 10.9723L10.2468 8.88662L11.3954 7.73801L12.2115 8.58436L13.602 7.22416L12.7556 6.37782L13.874 5.22921L15.9899 7.34507L17.35 5.95465L15.2644 3.86901L16.3828 2.75061Z"
      />
    </svg>
  );
};

export const Search = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
      onClick={props.clickEvent}
    >
      <path
        fill={fillColor}
        d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      ></path>
    </svg>
  );
};

export const SocialLink = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7 0-.24-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92 0-1.61-1.31-2.92-2.92-2.92z"
      ></path>
    </svg>
  );
};
export const SocialFacebook = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_421_3933)">
        <path
          fill={fillColor}
          d="M22.675 0H1.325C.594 0 0 .592 0 1.325v21.35C0 23.407.594 24 1.325 24h11.494v-9.294H9.69v-3.623h3.128V8.412c0-3.1 1.892-4.788 4.658-4.788 1.326 0 2.462.099 2.794.142v3.24h-1.918c-1.504 0-1.794.715-1.794 1.764v2.312h3.588l-.47 3.622H16.56V24h6.115c.732 0 1.326-.594 1.326-1.324V1.324C24 .592 23.406 0 22.675 0z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_421_3933">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const SocialLinkedIn = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <g clipPath="url(#clip0_421_3935)">
        <path
          fill={fillColor}
          d="M19 0H5a5 5 0 00-5 5v14a5 5 0 005 5h14a5 5 0 005-5V5a5 5 0 00-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_421_3935">
          <path fill="#fff" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export const Substract = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path fill={fillColor} d="M21 11.001H3v2h18v-2z"></path>
    </svg>
  );
};

export const Star = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27z"
      ></path>
    </svg>
  );
};

export const User = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M16.002 8c0 2.205-1.794 4-4 4-2.205 0-4-1.795-4-4s1.794-4 4-4 4 1.795 4 4zM4.002 19c0-3.533 3.29-6 8-6 4.711 0 8 2.467 8 6v1h-16v-1z"
      ></path>
    </svg>
  );
};

export const ViewShow = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M11.8 7.7998C9.59405 7.7998 7.80005 9.59481 7.80005 11.7998C7.80005 14.0058 9.59405 15.7998 11.8 15.7998C14.006 15.7998 15.8 14.0058 15.8 11.7998C15.8 9.59481 14.006 7.7998 11.8 7.7998ZM11.8 13.7998C10.697 13.7998 9.80005 12.9028 9.80005 11.7998C9.80005 10.6978 10.697 9.79981 11.8 9.79981C12.903 9.79981 13.8 10.6978 13.8 11.7998C13.8 12.9028 12.903 13.7998 11.8 13.7998Z"
      />
      <path
        fill={fillColor}
        d="M22.617 11.2248C22.4331 10.9618 18.022 4.7998 11.8 4.7998C5.57805 4.7998 1.16705 10.9618 0.983049 11.2248C0.739049 11.5698 0.739049 12.0308 0.983049 12.3758C1.16705 12.6378 5.57805 18.7998 11.8 18.7998C18.022 18.7998 22.4331 12.6378 22.617 12.3758C22.861 12.0298 22.861 11.5698 22.617 11.2248ZM11.8 16.7998C7.63405 16.7998 4.25105 13.2248 3.06905 11.7988C4.24805 10.3728 7.62005 6.7998 11.8 6.7998C15.966 6.7998 19.349 10.3758 20.531 11.8008C19.352 13.2278 15.98 16.7998 11.8 16.7998Z"
      />
    </svg>
  );
};

export const Warn = (props) => {
  ColorSwitch(props.color);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={fillColor}
        d="M13 10h-2v6h2v-6zM13.25 18a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0z"
      ></path>
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M3 22a1.003 1.003 0 01-.895-1.448l9-18c.339-.677 1.45-.677 1.789 0l9 18A1.003 1.003 0 0121 22H3zm16.382-2L12 5.237 4.618 20h14.764z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
